<template>
  <section class="krj-page">
    <slot />
  </section>
</template>

<script>
/**
 * PageContainer — 页面承载卡片
 * 撑满父容器 (app-main)，白底 / 圆角 / 轻阴影，内部按「标题栏 → 工具条 → 内容 → 分页」竖向排列。
 * 通常与 PageHeader / SearchBar / StandardDialog 搭配使用。
 */
export default {
  name: 'PageContainer'
}
</script>
